import routes from "../routes";

export const LOGIN_REDIRECT_PARAM = "redirect";
export const ADMIN_ROLE = "Administrator";

const ADMINISTRATION_PREFIX = routes.administration.search.split("/search")[0];
const ADMINISTRATION_USER_PATHS = [
  [routes.administration.search, routes.search],
  [routes.administration.tasks, routes.tasks],
  [routes.administration.taskTemplates, routes.taskTemplates],
  ["/administration/all-files", "/files"],
  [routes.administration.sprints, routes.sprints],
  ["/administration/all-objects", "/my-objects"],
];

export const isAdministrator = (user) => user?.role === ADMIN_ROLE;

const getLocationParts = (location) => {
  if (typeof location !== "string") {
    return {
      pathname: location?.pathname || "",
      search: location?.search || "",
      hash: location?.hash || "",
    };
  }

  const hashIndex = location.indexOf("#");
  const pathWithSearch =
    hashIndex === -1 ? location : location.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : location.slice(hashIndex);
  const searchIndex = pathWithSearch.indexOf("?");

  return {
    pathname:
      searchIndex === -1
        ? pathWithSearch
        : pathWithSearch.slice(0, searchIndex),
    search: searchIndex === -1 ? "" : pathWithSearch.slice(searchIndex),
    hash,
  };
};

export const getCurrentLocationPath = (location) =>
  `${location.pathname}${location.search}${location.hash}`;

export const getLoginPathWithRedirect = (location) => {
  const redirectTo = getCurrentLocationPath(location);
  const searchParams = new URLSearchParams({
    [LOGIN_REDIRECT_PARAM]: redirectTo,
  });

  return `${routes.login}?${searchParams.toString()}`;
};

export const getSafeRedirectPath = (redirectPath) => {
  if (
    !redirectPath ||
    typeof redirectPath !== "string" ||
    !redirectPath.startsWith("/") ||
    redirectPath.startsWith("//") ||
    redirectPath.startsWith(routes.login)
  ) {
    return routes.dashboards;
  }

  return redirectPath;
};

export const getRedirectPathForUser = (
  redirectPath,
  user,
  { preserveRequestedPath = true } = {}
) => {
  if (!preserveRequestedPath) {
    return routes.dashboards;
  }

  if (
    redirectPath.startsWith(ADMINISTRATION_PREFIX) &&
    !isAdministrator(user)
  ) {
    return getAdministrationFallbackPath(redirectPath);
  }

  return redirectPath;
};

export const getAdministrationFallbackPath = (location) => {
  const { pathname, search, hash } = getLocationParts(location);

  const fallback = ADMINISTRATION_USER_PATHS.find(([adminPath]) => {
    return pathname === adminPath || pathname.startsWith(`${adminPath}/`);
  });

  if (!fallback) {
    return routes.dashboards;
  }

  const [adminPath, userPath] = fallback;
  const suffix = pathname.slice(adminPath.length);

  return `${userPath}${suffix}${search}${hash}`;
};
